import { MapPin } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';

import { LOCATION_TYPES } from '@/pages/dashboard/mapping/model/constants';
import { LocationTypeFilter } from '@/pages/dashboard/mapping/model/types';

interface LocationFilterProps {
  filter: LocationTypeFilter;
  totalCount: number;
  filteredCount: number;
  onToggle: (type: keyof LocationTypeFilter) => void;
  onToggleAll: () => void;
}

export function LocationFilter({ filter, totalCount, filteredCount, onToggle, onToggleAll }: LocationFilterProps) {
  const allSelected = Object.values(filter).every((v) => v);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <MapPin className="w-4 h-4 mr-1" />
          Locations ({filteredCount}/{totalCount})
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-56">
        {(Object.keys(LOCATION_TYPES) as Array<keyof LocationTypeFilter>).map((type) => {
          const { Icon, label, color } = LOCATION_TYPES[type];
          return (
            <DropdownMenuItem
              key={type}
              className="cursor-pointer"
              onSelect={(e) => {
                e.preventDefault();
                onToggle(type);
              }}>
              <div className="flex items-center justify-between w-full">
                <div className="flex items-center gap-2">
                  <Checkbox checked={filter[type]} onCheckedChange={() => onToggle(type)} />
                  <span className={color}>
                    <Icon className="w-4 h-4" />
                  </span>
                  <span>{label}</span>
                </div>
              </div>
            </DropdownMenuItem>
          );
        })}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          className="cursor-pointer"
          onSelect={(e) => {
            e.preventDefault();
            onToggleAll();
          }}>
          <div className="flex items-center gap-2">
            <Checkbox checked={allSelected} />
            <span>Select All</span>
          </div>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
